import React from 'react';
import SEO from '../../components/ui/SEO';
import ServicePageTemplate from '../../components/ui/ServicePageTemplate';
import { servicePages } from '../../data/services';
export default function MentalCapacity() {
  return <main className="min-h-screen bg-white" data-id="element-1137" data-mp="gmn2i1tiqeti">
      <SEO title="Mental Capacity Assessments for Litigation | Dr Syed" description="Independent capacity assessments: litigation capacity, Court of Protection, deputyship, contested LPAs and testamentary capacity. Request a fee quote." path="/services/mental-capacity" keywords={['mental capacity assessment for litigation', 'Court of Protection psychiatric report', 'testamentary capacity assessment', 'retrospective capacity assessment']} imageAlt="Mental capacity assessments for litigation and the Court of Protection" schema={{
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Mental Capacity Assessments',
      serviceType: 'Mental capacity assessment',
      url: 'https://medicolegal-psychiatry.co.uk/services/mental-capacity',
      areaServed: {
        '@type': 'AdministrativeArea',
        name: 'England and Wales'
      },
      provider: {
        '@type': 'Organization',
        name: 'Medicolegal Psychiatry',
        url: 'https://medicolegal-psychiatry.co.uk'
      },
      audience: {
        '@type': 'Audience',
        name: 'Legal professionals'
      },
      description: 'Decision-specific capacity assessments under the Mental Capacity Act 2005, including litigation capacity, Court of Protection property and affairs, deputyship, lasting powers of attorney and testamentary capacity.'
    }} data-id="element-1138" data-mp="gprh7t4m0syf" />
      <ServicePageTemplate content={servicePages.capacity} data-id="element-1139" data-mp="2aspwpywsp5gm" />
    </main>;
}